import React from 'react';
import {connect} from 'react-redux';
import {useParams} from 'react-router-dom';
import PropTypes from 'prop-types';
import debug from 'debug';
import axiosInstance from '../../shared/utils/axios';
import {Button, DescriptiveText, LoadingSpinner, Row} from '../../shared';
import Dashboard from '../components/Dashboard';
import styled, {withTheme} from 'styled-components/macro';
import {_openModal} from '../../shared/reducers/modals';
import {_getDefaultContainerID} from '../../advisor/reducers/defaultContainerID';
import history from '../../history';
import {getHexWithOpacity} from '../../shared/utils/colors';
import useSWR from 'swr';

const log = debug('circleblack:investor:pages:DashboardPage');

const _Spinner = styled(LoadingSpinner)`
  margin: 100px 0 0 0;
`;

const DashboardPage = ({session, openModal, theme}) => {
  log('rendering');

  const {id} = useParams();

  let contextUrl;

  const basePathArr = window.location.pathname.split('/');
  const basePath = (basePathArr.length >= 2) ? basePathArr[1] : null;

  if (basePath === 'portfolio') {
    contextUrl = '/containers?type=portfolio';
  } else if (basePath === 'groups') {
    contextUrl = `/containers/${id}`;
  } else if (basePath === 'accounts') {
    contextUrl = `/containers/${id}`;
  }

  const {data: container} = useSWR(contextUrl, url => axiosInstance.get(url).then(res => (
    (basePath === 'portfolio') ? (res.data[0] || null) : (res.data || null)
  )));

  if (!session || (typeof container === 'undefined')) {
    return <_Spinner/>;
  }

  return (
    <>
      {(basePath === 'portfolio' && !container)
          && <Row
              justifySubRow={'space between'}
              backgroundColor={getHexWithOpacity(theme.primaryColor, 0.5)}
              margin={'10px'}
              borderRadius={'6px'}
              style={{padding: '5px 15px 5px 15px'}}>
            <DescriptiveText width={'fit-content'}
                             fontSize={'14px'}
                             maxWidth={'fill'}
                             margin={'0 auto'}>
              {`There are no accounts connected to the platform at this time. Add accounts or contact your ${session.profile.advisorTerm.toLowerCase()} if you need further assistance.`}
            </DescriptiveText>
            <Row maxWidth={'fit-content'} margin={'0 auto'}>
              <Button size={'md'}
                      importance={'secondary'}
                      width={'165px'}
                      label={'Manually Add Assets'}
                      action={() => openModal({
                        type: 'ManuallyAddAssets',
                        onSuccess: () => {
                          history.push('/accounts');
                        },
                      })}/>
              <Button size={'md'}
                      importance={'secondary'}
                      width={'165px'}
                      label={'Connect to Institution'}
                      action={() => history.push('/accounts/aggregation', {backLocation: '/portfolio'})}/>
            </Row>
          </Row>}
      <Dashboard context={{
        containerID: container?.id,
        name: container?.name,
        id: session?.profile?.id,
        type: container?.type}} container={container}/>
    </>
  );
};

const mapDispatchToProps = dispatch => ({
  openModal: modalToOpen => dispatch(_openModal(modalToOpen)),
  getDefaultContainerID: () => dispatch(_getDefaultContainerID()),
});

const mapStateToProps = state => ({
  session: state.session,
});

export default withTheme(connect(mapStateToProps, mapDispatchToProps)(DashboardPage));

DashboardPage.propTypes = {
  session: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
};
